import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-employeefeatures',
  templateUrl: './EmployeeFeatures.component.html'
})
export class EmployeeFeaturesComponent implements OnInit {

    public displayDialog: boolean;
    public selectedFeatures: ent.Feature[] = [];
    public availableFeatures: ent.Feature[] = [];

    employeeForm: FormGroup;

    
    @Input() public employee: ent.Employee;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 

    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

    onSaveFeatures(event: any){
        this.onOK.emit();
        
        this.displayDialog = false;
    }

}